import React from "react";

import { Redirect } from "react-router";

import cache, { cacheItems } from "../cache";
import globalContext from "../../context/globalContext";

import _ from "lodash";

class Redirects extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      fetched: false,
      isShoppingCart: false,
      redirected: false
    };
  }

  render() {
    const token = cache.getItem(cacheItems.USER_TOKEN);
    const userUuid = cache.getItem(cacheItems.USER_UUID);
    const puliUuid = cache.getItem(cacheItems.POP_UP_LOCATION_INSTANCE_UUID);
    const prevZip = cache.getItem(cacheItems.PREVIOUS_ZIP_CODE);
    const user = this.context.global.data.user;

    if (!token || !userUuid) {
      this.context.global.stateHardReset(true);
      return <Redirect to="/login" />;
    }

    // redirect if puli is not set in cache
    if (!puliUuid && this.props.location.pathname === "/dashboard") {
      this.context.global.stateHardReset();

      if (prevZip) {
        return <Redirect to={`/find-hot-spot/${prevZip}`} />;
      } else {
        let userDeliveryZip;
        if (user && user.locations) {
          userDeliveryZip = _.find(user.locations, location => {
            return location.isPrimary === 1;
          });
        }

        if (userDeliveryZip) {
          return <Redirect to={`/find-hot-spot/${userDeliveryZip.zip}`} />;
        } else {
          return <Redirect to={`/find-hot-spot`} />;
        }
      }
    }

    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

export default Redirects;
